module.exports = __webpack_public_path__ + "static/media/video_reactangle_icon_big.a8de5fde.svg";